module.exports = __webpack_public_path__ + "static/media/Affordablity_Hero.55b2b650.png";